import {
    HISTORY_SUCCESS,
    HISTORY_FAILED,
    HISTORY_REQUEST,
    HISTORY_CLEAR

} from "../constants";

import { RSAA } from 'redux-api-middleware';
import { withAuth } from '../reducers'

export const fetchHistoryData = (URL) => ({
  [RSAA]: {
      endpoint: `${URL}`,
      method: 'GET',
      headers: withAuth({ 'Content-Type': 'application/json' }),
      types: [
        HISTORY_REQUEST, HISTORY_SUCCESS, HISTORY_FAILED
      ]
  }
})

export const historySuccessData = () => {
    return {
        type:HISTORY_SUCCESS,
        playload: ''
    }
}

export const clearHistoryData = () => {
    return {
        type: HISTORY_CLEAR,
        playload: ''
    }
}



// WEBPACK FOOTER //
// ./src/actions/history.js